// --- Biome Manager Class ---
// Manages available themes and applies them to the UI.
export class BiomeManager {
    /**
 * Creates an instance of BiomeManager.
 *
 * @constructor
 * @param {*} dependencies 
 */
    constructor(dependencies) {
        this.targetElement = dependencies.targetElement;
        this.gridElement = dependencies.gridElement;
        this.biomes = dependencies.biomes;
        this.currentBiome = 'default';
        this.applyBiome(this.currentBiome);
    }

    /**
 * Description placeholder
 *
 * @returns {string} 
 */
    getCurrentBiomeKey() {
        return this.currentBiome;
    }

    /**
 * Description placeholder
 *
 * @param {*} biomeName 
 */
    applyBiome(biomeName) {
        if (!this.biomes[biomeName]) return;

        // Remove old theme class
        if (this.biomes[this.currentBiome] && this.biomes[this.currentBiome].cssClass) {
            this.targetElement.classList.remove(this.biomes[this.currentBiome].cssClass);
            if (this.gridElement) {
                this.gridElement.classList.remove(this.biomes[this.currentBiome].cssClass);
            }
        }

        // Add new theme class
        if (this.biomes[biomeName].cssClass) {
            this.targetElement.classList.add(this.biomes[biomeName].cssClass);
            if (this.gridElement) {
                this.gridElement.classList.add(this.biomes[biomeName].cssClass);
            }
        }
        this.currentBiome = biomeName;
    }
}